module.exports = __webpack_public_path__ + "034ca86e2ddcf6bbdafecf31278e2384.svg";